import React from "react";
import AppRoutes from "./Routes";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "./pages/Header/Header";
import { UserProvider } from "./context/UserContext";
import Footer from "./pages/Footer/Footer";

const App: React.FC = () => {
  const location = useLocation();
  const routesWithHeaderFooter = ["/"];
  const shouldRenderHeaderFooter = routesWithHeaderFooter.includes(
    location.pathname
  );
  const navigate = useNavigate();

  return (
    <div className="app-container m-auto">
      <UserProvider>
        {shouldRenderHeaderFooter && <Header />}
        <div className="main-container">
          <AppRoutes />
        </div>
        {/* {shouldRenderHeaderFooter && <Footer />} */}
      </UserProvider>
      <ToastContainer newestOnTop />
    </div>
  );
};

export default App;
